import { Link } from "react-router-dom";
import SupportContactHint from "./SupportContactHint";

/** Footer on public pages: help contact + legal links. */
export default function SiteFooter() {
  return (
    <footer className="site-footer">
      <SupportContactHint />
      <nav className="site-footer-links" aria-label="Site">
        <Link to="/about">About</Link>
        <span aria-hidden="true">·</span>
        <Link to="/privacy">Privacy Policy</Link>
        <span aria-hidden="true">·</span>
        <Link to="/terms">Terms of Service</Link>
      </nav>
    </footer>
  );
}
